import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f14aad0")

_pushScopeId("data-v-2f14aad0")
const _hoisted_1 = { class: "ExpressMultiTasks" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "ExpressMultiTasks__title" }, "Выбор дополнительных задач", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "(необязательно)", -1)
const _hoisted_4 = { class: "ExpressMultiTasks__body" }
const _hoisted_5 = {
  key: 0,
  class: "ExpressMultiTasks__state state--loading"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "state--text text--loading" }, "Загрузка списка задач...", -1)
const _hoisted_7 = {
  key: 1,
  class: "ExpressMultiTasks__state state--failed"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "state--text text--failed" }, " При загрузке списка задач произошла ошибка ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Перезагрузить")
const _hoisted_10 = {
  key: 1,
  class: "ExpressMultiTasks__list"
}
const _hoisted_11 = { style: {"max-width":"400px"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Удалить")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Выбрать ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" test ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_ctx.loading || _ctx.failed)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_s_loader),
                  _hoisted_6
                ]))
              : (_ctx.failed)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_s_button, {
                      class: "blue",
                      disabled: _ctx.disabled,
                      onClick: _ctx.emitReload
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
              return (_openBlock(), _createBlock("div", {
                key: task.id,
                class: "list__item"
              }, [
                _createVNode("div", null, [
                  _createVNode("p", _hoisted_11, [
                    (task.id === 2)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(task.title) + " (Сумма доставки х2)", 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(task.title), 1)
                        ], 64))
                  ]),
                  _createVNode("p", null, [
                    (task.id === 2)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(task.price * 2) + " тенге", 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(task.price) + " тенге", 1)
                        ], 64))
                  ])
                ]),
                (_ctx.selectedTasksIds.includes(task.id))
                  ? (_openBlock(), _createBlock(_component_s_button, {
                      key: 0,
                      class: "black",
                      disabled: _ctx.disabled,
                      onClick: ($event: any) => (_ctx.emitUnselect(task.id))
                    }, {
                      default: _withId(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_s_button, {
                      key: 1,
                      class: "blue",
                      disabled: _ctx.disabled,
                      onClick: ($event: any) => (_ctx.emitSelect(task))
                    }, {
                      default: _withId(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
              ]))
            }), 128))
          ]))
    ]),
    false
      ? (_openBlock(), _createBlock(_component_s_button, { key: 0 }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})